const user = {
  first_name: "Nombre",
  last_name: "Apellido",
  email: "Correo electrónico",
  gender: "Género",
  phone_number: "Celular",
  birthday_with_format: "Fecha de nacimiento mm/dd/aaaa",
  gender_options: {
    male: "Hombre",
    female: "Mujer",
    unspecified: "Prefiero no decir",
  },
  culture_id: "Seleccione el país de origen de su familia",
  other_culture_name: "Especificar el país de origen de su familia",
  mexico_state_id: "¿De qué estado de México proviene su familia?",
  interests: "Intereses",
  language: "Idioma",
  language_options: {
    spanish: "Español",
    english: "Inglés",
  },
  profile: {
    account_info: "Detalles",
    add_card: "Agregar tarjeta",
    add_new_card: "Agregar tarjeta nueva",
    annual_interval: "año",
    annual_plan: "PODERsalud anual",
    cancel_edit_cta: "Cancelar",
    card_info: "Información de la tarjeta",
    default: "Preferido",
    expires_on: "Caduca el",
    make_default: "Establecer como método de pago preferido",
    monthly_interval: "mes",
    monthly_plan: "PODERsalud mensual",
    next_billing: "Fecha de cobro",
    payment_cta_title: "Facturación",
    payment_methods: "Métodos de pago",
    plan: "Plan",
    price: "Precio",
    submit_cta: "Aplicar cambios",
  },
};

export default user;
